import cx from "classnames";
import React from "react";
import BullseyeArrowIcon from "./BullseyeArrowIcon";
import Section from "../Section";
import Skill from "./Skill";
import ChartLineUpIcon from "./ChartLineUpIcon";
import MicrochipAiIcon from "./MicrochipAiIcon";

const Skills: React.FC = (): React.ReactElement => (
  <Section className="u-background-color-primary" id="Skills">
    <div
      className={cx([
        "u-align-items-center",
        "u-flex",
        "u-flex-column",
        "u-margin-bottom-negative-0point875rem",
        "u-margin-top-negative-0point875rem",
      ])}
    >
      <div
        className={cx([
          "u-flex",
          "u-flex-column",
          "u-justify-content-center",
          "u-padding-bottom-0point875rem",
          "u-padding-top-0point875rem",
          "u-width-full",
        ])}
      >
        <p
          className={cx([
            "u-color-secondary",
            "u-font-size-l",
            "u-line-height-s",
            "u-margin-bottom-0",
            "u-margin-top-0",
            "u-text-center",
            "u-text-normal",
          ])}
        >
          Skills
        </p>
        <div>
          <hr
            className={cx([
              "u-border-color-secondary",
              "u-horizontal-rule",
              "u-margin-bottom-0",
            ])}
          />
        </div>
      </div>
      <div
        className={cx([
          "u-flex",
          "u-margin-bottom-negative-1rem",
          "u-margin-top-negative-0point875rem",
          "u-padding-0point875rem",
        ])}
      >
        <div
          className={cx(
            "u-flex",
            "u-flex-row",
            "u-flex-wrap",
            "u-justify-content-center",
            "u-width-full",
          )}
        >
          <div className={cx("julia-website-skill", "u-padding-0point875rem")}>
            <Skill
              description="I design learning programs that align business goals, learner needs, and real-world application. By structuring cohesive learning journeys, I help organizations move from isolated training to intentional, scalable learning experiences."
              header="Learning Program Strategy & Learning Experience Architecture"
              icon={
                <BullseyeArrowIcon
                  className="u-position-relative"
                  fill="#5A7864"
                  height={45}
                />
              }
            />
          </div>
          <div className={cx("julia-website-skill", "u-padding-0point875rem")}>
            <Skill
              description="I use data to guide learning decisions and measure what truly matters. From needs analysis to outcomes evaluation, I translate insights into actionable improvements that increase effectiveness and impact."
              header="Data-Informed Decision Making & Learning Impact"
              icon={
                <ChartLineUpIcon
                  className="u-position-relative"
                  fill="#5A7864"
                  height={45}
                />
              }
            />
          </div>
          <div className={cx("julia-website-skill", "u-padding-0point875rem")}>
            <Skill
              description="I leverage learning technologies and AI-enabled tools to enhance design, delivery, and personalization. My focus is on practical, ethical solutions that improve learning efficiency while keeping the human experience at the center."
              header="Learning Technology & AI-Enabled Solutions"
              icon={
                <MicrochipAiIcon
                  className="u-position-relative"
                  fill="#5A7864"
                  height={45}
                />
              }
            />
          </div>
        </div>
      </div>
    </div>
  </Section>
);

export default React.memo(Skills);
